export default {
  setResourceGroups(state, payload) {
    state.resourceGroups = payload
  },
  addResourceGroup(state, payload) {
    let old_gr = state.resourceGroups
    if (payload && !old_gr.some(y => y.id == payload?.id)) {
      state.resourceGroups.push(payload)
    }
  },
  setResources(state, payload) {
    state.resources = payload
  },
  setMesurements(state, payload) {
    state.measurements = payload
  },
  addResources(state, payload) {
    let oldRes = state.resources
    payload.forEach(w => {
      if (!oldRes.some(y => y.id == w.id)) {
        state.resources.push(w)
      }
    })
  },
}